import {Component, OnInit} from '@angular/core';

import {HomeService} from './home.service';
import {HomeModel} from './home.model';
import {StatisticsGroupModel} from '../shared/objects/statistics-group.model';

@Component({
  selector: 'app-home',
  providers: [HomeService],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {

  homeStatistics: HomeModel[];
  statisticsGroupModel: StatisticsGroupModel[];

  constructor(private homeService: HomeService) {
  }

  ngOnInit() {

    this.homeService.getNotifications()
      .subscribe(
        (homeStatistics: HomeModel[]) => this.homeStatistics = homeStatistics,
        (error) => console.log(error)
      );

    this.homeService.getHomeAnalytics()
      .subscribe(
        (response) => {
          this.statisticsGroupModel = response;
        },
        (error) => console.log(error)
      );
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/home/home.component.ts